import React, { useState } from "react";
import { Modal, Form, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./ReceiveCashModal.css";

import {
  faCaretLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import BlueBtn from "../../../../common/common_btn/blueBtn/BlueBtn";

import avatarImg from "../../../../assets/images/header_images/user.png";

import ReceiveCash2Modal from "../../../../common/common_modal/receivecash2Modal/ReceiveCash2Modal";

import ConfirmationModal from "../../../../common/common_modal/confirmationModal/ConfirmationModal";

const ReceiveCashModal = ({
  show = false,
  onHide,

  title = "Receive Cash",

  // =========================================================
  // PAYMENT CALLBACKS
  // =========================================================

  onPaymentYes,
  onPaymentNo,

  // =========================================================
  // SALES PERSON
  // =========================================================

  salesPersons = [
    {
      id: 1,
      name: "Oshin Kawale",
    },
    {
      id: 2,
      name: "Pravin Waghmare",
    },
    {
      id: 3,
      name: "Prem Rokade",
    },
  ],

  // =========================================================
  // DELIVERY PERSON
  // =========================================================

  deliveryPerson = {
    date: "12 Aug 2026",
    name: "Oshin Kawale",
    collectedCash: 3450,
  },

  onContinueSalesPerson,
  onReceiveDeliveryCash,
}) => {

  // =========================================================
  // STATES
  // =========================================================

  const [selectedType, setSelectedType] =
    useState("sales");

  const [searchTerm, setSearchTerm] =
    useState("");

  const [selectedPersonId, setSelectedPersonId] =
    useState(null);

  const [showReceiveCash2Modal, setShowReceiveCash2Modal] =
    useState(false);

  const [selectedPerson, setSelectedPerson] =
    useState(null);

  const [showConfirmationModal, setShowConfirmationModal] =
    useState(false);

  // =========================================================
  // FILTER SALES PERSON
  // =========================================================

  const filteredSalesPersons = salesPersons.filter(
    (person) =>
      person.name
        .toLowerCase()
        .includes(searchTerm.toLowerCase())
  );

  // =========================================================
  // OPEN RECEIVE CASH 2
  // =========================================================

  const handleOpenReceiveCash2Modal = (person) => {

    setSelectedPersonId(person.id);

    setSelectedPerson(person);

    if (onHide) {
      onHide();
    }

    setShowReceiveCash2Modal(true);
  };

  // =========================================================
  // CLOSE RECEIVE CASH 2
  // =========================================================

  const handleReceiveCash2ModalClose = () => {
    setShowReceiveCash2Modal(false);
  };

  // =========================================================
  // CONTINUE SALES PERSON
  // =========================================================

  const handleContinue = () => {

    if (!selectedPersonId) {
      return;
    }

    const person = salesPersons.find(
      (item) => item.id === selectedPersonId
    );

    if (!person) {
      return;
    }

    if (onContinueSalesPerson) {
      onContinueSalesPerson(selectedPersonId);
    }

    handleOpenReceiveCash2Modal(person);
  };

  // =========================================================
  // RECEIVE CASH
  // =========================================================

  /*
   * Receive Cash
   *
   * ↓
   *
   * Payment Confirmation
   */

  const handleReceiveCash = () => {

    /*
     * Close Receive Cash 2
     */

    setShowReceiveCash2Modal(false);

    /*
     * Close main Receive Cash
     */

    if (onHide) {
      onHide();
    }

    /*
     * Open Payment Confirmation
     */

    setShowConfirmationModal(true);
  };

  // =========================================================
  // PAYMENT CONFIRMATION CLOSE
  // =========================================================

  const handleConfirmationClose = () => {
    setShowConfirmationModal(false);
  };

  // =========================================================
  // PAYMENT CONFIRMATION -> NO
  // =========================================================

  /*
   * NO
   *
   * ↓
   *
   * Today's Cash Collection
   */

  const handleNoButtonClick = () => {

    setShowConfirmationModal(false);

    if (onPaymentNo) {
      onPaymentNo();
    }
  };

  // =========================================================
  // PAYMENT CONFIRMATION -> YES
  // =========================================================

  /*
   * YES
   *
   * ↓
   *
   * Cash Collected
   */

  const handleYesButtonClick = () => {

    setShowConfirmationModal(false);

    if (onPaymentYes) {
      onPaymentYes();
    }
  };

  // =========================================================
  // JSX
  // =========================================================

  return (
    <>
      {/* =====================================================
          RECEIVE CASH MODAL
      ===================================================== */}

      <Modal
        show={show}
        onHide={onHide}
        centered
        className="ReceiveCashModal common_modal"
      >

        {/* ===================================================
            HEADER
        =================================================== */}

        <Modal.Header closeButton>

          <div className="LogoutConfirmationModal_header_content">

            <button
              type="button"
              className="LogoutConfirmationModal_back_btn back-btn"
              onClick={onHide}
              aria-label="Back"
            >

              <span className="back-arrow">

                <FontAwesomeIcon
                  icon={faCaretLeft}
                />

              </span>

            </button>

            <Modal.Title
              className="LogoutConfirmationModal_title"
            >
              {title}
            </Modal.Title>

          </div>

        </Modal.Header>

        {/* ===================================================
            BODY
        =================================================== */}

        <Modal.Body>

          {/* =================================================
              TYPE SELECTION
          ================================================= */}

          <Form>

            <div className="radio_container">

              {/* SALES PERSON */}

              <div
                className={`radio-tab-card ${
                  selectedType === "sales"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setSelectedType("sales")
                }
              >

                <Form.Check
                  type="radio"
                  id="radio-sales"
                  name="cashReceiverType"
                  label="By Sales Person"
                  checked={
                    selectedType === "sales"
                  }
                  onChange={() =>
                    setSelectedType("sales")
                  }
                />

              </div>

              {/* DELIVERY PERSON */}

              <div
                className={`radio-tab-card ${
                  selectedType === "delivery"
                    ? "active"
                    : ""
                }`}
                onClick={() =>
                  setSelectedType("delivery")
                }
              >

                <Form.Check
                  type="radio"
                  id="radio-delivery"
                  name="cashReceiverType"
                  label="By Delivery Person"
                  checked={
                    selectedType === "delivery"
                  }
                  onChange={() =>
                    setSelectedType("delivery")
                  }
                />

              </div>

            </div>

          </Form>

          <div className="hr_divider" />

          {/* =================================================
              SALES PERSON
          ================================================= */}

          {selectedType === "sales" && (

            <div className="sales-person-tab">

              {/* SEARCH */}

              <Form.Group
                className="search_group"
              >

                <Form.Control
                  type="text"
                  placeholder="Search Salesperson Name"
                  value={searchTerm}
                  onChange={(event) =>
                    setSearchTerm(
                      event.target.value
                    )
                  }
                  className="search_input"
                />

              </Form.Group>

              {/* PERSON LIST */}

              <div className="person-list">

                {filteredSalesPersons.length > 0 ? (

                  filteredSalesPersons.map(
                    (person) => (

                      <Card
                        key={person.id}
                        className={`person-card ${
                          selectedPersonId ===
                          person.id
                            ? "selected"
                            : ""
                        }`}
                        onClick={() =>
                          handleOpenReceiveCash2Modal(
                            person
                          )
                        }
                      >

                        <Card.Body
                          className="card_body_content"
                        >

                          <div className="person_details">

                            <img
                              src={avatarImg}
                              alt={person.name}
                              className="person-avatar"
                            />

                            <span className="person-name">
                              {person.name}
                            </span>

                          </div>

                          <FontAwesomeIcon
                            icon={faChevronRight}
                            className="chevron-icon"
                          />

                        </Card.Body>

                      </Card>

                    )
                  )

                ) : (

                  <div className="no_person_found">
                    No salesperson found.
                  </div>

                )}

              </div>

              {/* CONTINUE */}

              <div className="actions_btn_holder">

                <BlueBtn
                  btnText="Continue"
                  onClick={handleContinue}
                />

              </div>

            </div>

          )}

          {/* =================================================
              DELIVERY PERSON
          ================================================= */}

          {selectedType === "delivery" && (

            <div className="delivery-person-tab">

              <Card className="cash-summary-card">

                <Card.Body>

                  <div className="summary_top_info">

                    <span className="delivery_date">
                      {deliveryPerson.date}
                    </span>

                    <span className="summary_label">
                      (Todays Collected Cash)
                    </span>

                  </div>

                  <div className="summary_bottom_info">

                    <div className="person_details">

                      <img
                        src={avatarImg}
                        alt={deliveryPerson.name}
                        className="person-avatar"
                      />

                      <span className="person-name">
                        {deliveryPerson.name}
                      </span>

                    </div>

                    <span className="cash-amount">
                      ₹ {deliveryPerson.collectedCash}
                    </span>

                  </div>

                </Card.Body>

              </Card>

              <div className="actions_btn_holder">

                <BlueBtn
                  btnText="Receive cash"
                  onClick={() => {

                    if (onReceiveDeliveryCash) {
                      onReceiveDeliveryCash(
                        deliveryPerson
                      );
                    }

                    handleReceiveCash();
                  }}
                />

              </div>

            </div>

          )}

        </Modal.Body>

      </Modal>

      {/* =====================================================
          RECEIVE CASH 2 MODAL
      ===================================================== */}

      <ReceiveCash2Modal
        show={showReceiveCash2Modal}
        onHide={handleReceiveCash2ModalClose}
        date="12 Aug 2026"
        personName={
          selectedPerson?.name ||
          "Ankit Patil"
        }
        collectedCash={3450}
        selectedPerson={selectedPerson}
        onReceiveCash={handleReceiveCash}
      />

      {/* =====================================================
          PAYMENT CONFIRMATION
      ===================================================== */}

      <ConfirmationModal
        show={showConfirmationModal}
        onHide={handleConfirmationClose}
        title="Payment Confirmation"
        statusTitle="Have You Collected Payment?"
        message={
          <>
            Please confirm that the payment has been
            collected From the Sale person.

            <div className="hr_divider" />
          </>
        }
        noButtonText="No, Collect Payment"
        yesButtonText="Yes, Collected"
        onNoButtonClick={handleNoButtonClick}
        onYesButtonClick={handleYesButtonClick}
        className="PaymentConfirmationModal"
      />

    </>
  );
};

export default ReceiveCashModal;